<div class="pagetitle">
  <h2>List Projects</h2>
  <a [routerLink]="['/dashboard/project/new']" class="btn btn-sm btn-outline-success"><i class="fa fa-fw fa-plus"></i> Create new project</a>
</div>
<alert></alert>

<div class="filter form-row">
  <div class="col-md-6">
    <form [formGroup]="recordLimitForm" class="float-left" novalidate>
      <select class="form-control form-control-sm" formControlName="recordlimit" (change)="updateRecords($event.target.value)">
        @for (option of pagination['options']; track option) {
          <option value="{{option.key}}">{{option.value}}</option>
        }
      </select>
    </form>
  </div>
  <div class="col-md-6">
    <form [formGroup]="projectSearchForm" class="float-right" novalidate>
      <input type="text" class="form-control form-control-sm" formControlName="name" placeholder="Project name" />
      @if (filter) {
        <i class="fa fa-fw fa-times"></i>
      }
      @if (!filter) {
        <i class="fa fa-fw fa-search"></i>
      }
    </form>
  </div>
</div>
<div class="table-responsive">
  <table class="table table-bordered table-striped table-sm table-hover" id="dataTable" width="100%" cellspacing="0">
    <thead>
      <tr>
        <th width="200" [index]="1" [resizeColumn]="true" (click)="sort(sortMethodTypes.NAME)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.NAME, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.NAME && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.NAME && sortDirection === 'DESC') }">Project Name</th>

        @if (authService.hasAccess('PartnerAdmin')) {
          <th width="160" [index]="0" [resizeColumn]="true" (click)="sort(sortMethodTypes.CUSTOMER_NAME)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.CUSTOMER_NAME, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.CUSTOMER_NAME && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.CUSTOMER_NAME && sortDirection === 'DESC') }">Customer</th>
        }

        @if (authService.hasAccess('SuperAdmin')) {
          <th width="160" [index]="0" [resizeColumn]="true" (click)="sort(sortMethodTypes.PARTNER_NAME)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.PARTNER_NAME, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.PARTNER_NAME && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.PARTNER_NAME && sortDirection === 'DESC') }">Partner</th>
        }

        <th width="60" [index]="2" [resizeColumn]="true" class="sort-na">Status</th>

        <th width="120" [index]="3" [resizeColumn]="true" (click)="sort(sortMethodTypes.CREATION_DATE)"
          [ngClass]="{'fa-sort': sortMethod !== sortMethodTypes.CREATION_DATE, 
          'fa-sort-asc': (sortMethod === sortMethodTypes.CREATION_DATE && sortDirection === 'ASC'), 
          'fa-sort-desc': (sortMethod === sortMethodTypes.CREATION_DATE && sortDirection === 'DESC') }">Creation Date</th>

        <th width="" [index]="4" [resizeColumn]="true" class="sort-na">S3 Folder path</th>
        <th width="250" [index]="5" [resizeColumn]="true" class="sort-na">Action</th>
      </tr>
    </thead>
    <tbody>
      @if (loading) {
        <tr>
          <td colspan="6" class="loading text-center">
            <span class="">{{msg}}</span>
          </td>
        </tr>
      }
      @for (project of projects; track project; let i = $index) {
        <tr>
          <td><a [routerLink]="['/dashboard/project/', 'view', project.id]" [state]="{ data: { project: project }}">{{project.name}}</a></td>
          @if (authService.hasAccess('PartnerAdmin')) {
            <td>{{project.customer?.name}}</td>
          }
          @if (authService.hasAccess('SuperAdmin')) {
            <td>{{project.partner?.name}}</td>
          }
          <td class="text-center">
            @if (project.status=='active') {
              <span class="badge badge-success">{{project.status}}</span>
            }
            @if (project.status=='inactive') {
              <span class="badge badge-secondary">{{project.status}}</span>
            }
            @if (project.status=='DIP') {
              <span class="badge badge-danger" placement="bottom" ngbTooltip="Project deletion is in progress.">DIP</span>
            }
          </td>
          <td>{{project.createdAt | date:'shortDate' }}</td>
          <td title="{{project.s3Path}}" class="ellepsis"><span placement="left"
          ngbPopover="{{project.s3Path}}" [autoClose]="'outside'" popoverTitle="S3 Folder Path">{{project.s3Path}}</span></td>
          <td class="text-center">
            <a class="btn btn-primary btn-xs" [routerLink]="[]" (click)="viewProject(project)" [style.color]="'white'" title="view project"><i class="fas fa-eye"></i> View</a>&nbsp;
            <a  class="btn btn-assign btn-xs" href="javascript:;" title="Assigned User" placement="left"
              [ngbPopover]="popContent" #assignPopover="ngbPopover" triggers="manual" popoverTitle="Assigned Users" (click)="togglePopover(assignPopover, project)">
              <i class="fa fa-fw fa-users"></i> Assign
            </a>&nbsp;
            <a class="btn btn-secondary btn-xs" [routerLink]="['/dashboard/project', project.id, 'tags']" [state]="{ data: { project: project }}" title="Project Tags"><i class="fas fa-tag"></i> Tags</a>&nbsp;
            <a class="btn btn-secondary btn-xs" [routerLink]="['/dashboard/project', project.id, 'imports']" [state]="{ data: { project: project }}" title="Import History"><i class="fas fa-file-import"></i> Media Imports</a>&nbsp;
            <a class="btn btn-edit btn-xs" [routerLink]="['/dashboard/project/', 'edit', project.id]" [state]="{ data: { project: project }}" title="Edit Project"><i class="fa fa-fw fa-edit"></i> Edit</a>&nbsp;
            <a class="btn btn-delete btn-xs"href="javascript:;" (click)="deleteProject(project)" title="Delete Project"><i class="fa fa-fw fa-trash"></i> Delete</a>
          </td>
        </tr>
      }
    </tbody>
  </table>
  <!-- Pagination Interface -->
  @if (pagination['show']) {
    <nav aria-label="Page navigation">
      <ul class="pagination">
        <li class="page-item"><a class="page-link" [ngClass]="(currentPage == 1 ) ? 'disabled' : ''" href="javascript:;" (click)="paginate('previous')">Previous</a></li>
        <li class="page-item"><a class="page-link text" href="javascript:;">Page {{currentPage}} of {{pagination['pages']}}</a></li>
        <li class="page-item"><a class="page-link" [ngClass]="(currentPage == pagination['pages'] ) ? 'disabled' : ''" href="javascript:;" (click)="paginate('forward')">Next</a></li>
      </ul>
    </nav>
  }
</div>
<ng-template #popContent let-project="project">
  @if (project.users.length > 0) {
    <ul class="assigned-users">
      @for (user of project.users; track user) {
        <li>{{ user.email }}</li>
      }
    </ul>
  }
  @if (project.users.length === 0) {
    <div>No users assigned</div>
  }
  <a [routerLink]="['/dashboard/project/assign', (project.id)]" [state]="{ data: { project: project }}"  title="Assign User">Assign/Modify User</a>
</ng-template>